import React from 'react'

import './Footer.scss'

function Footer() {
    return <div className="footer noselect">Copyright © {new Date().getFullYear()} Ocean Fresh. All Rights Reserved.</div>
}

export default Footer
